<template>
  <v-row>
    <v-col>
      <v-snackbar
          :key="index"
          v-model="show"
          right
          top
          multi-line
          :timeout="timeout"
          vertical
          :light="$vuetify.theme.dark"
          :dark="!$vuetify.theme.dark">
        <v-row>
          <v-col cols="12" class="my-2 text-h5">
            {{ $t('Новая заявка') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="my-0 py-0 text-subtitle-1">
            {{ $t('Время выставления:') }}
          </v-col>
          <v-col cols="12" class="my-0 py-0">
            {{ order.orderDate ?
              $moment(order.orderDate).format('DD.MM.YYYY HH:mm:ss')
              : null }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" my-2>
            <v-btn
                text
                color="red"
                @click="close">
              {{ $t('Закрыть') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>

  export default {
    components: {

    },
    props: {
      index: {
        type: [Number, String],
        required: true
      },
      order: {
        type: Object,
        required: true
      },
      timeout: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        show: true
      }
    },
    computed: {
      headers () {
        return [
          { text: this.$t('Наименование позиции'), sortable: false, value: 'positionDescription' },
          { text: this.$t('Премия/дисконт'), sortable: false, value: 'premiumWithDelivery' }
        ]
      }
    },
    watch: {
      timeout (value) {
        if (!value || value === 0) {
          this.hide()
        }
      },
      show (value) {
        if (!value) {
          this.hide()
        }
      }
    },
    methods: {
      close: function () {
        this.$emit('close', this.index)
      },
      hide: function () {
        this.$emit('close', 0)
      }
    }
  }
</script>
